import { render, staticRenderFns } from "./checkboxField.vue?vue&type=template&id=71afd9e2&"
import script from "./checkboxField.vue?vue&type=script&lang=ts&"
export * from "./checkboxField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports